import { BriefcaseIcon } from "@heroicons/react/outline";

import { IndividualInviteCardProps } from "./types";

import { Button } from "@/components/ui/button";
import { formatTimestamp } from "@/utils/timestamp";

export const IndividualInviteCard = ({
  invite,
  onAccept,
  onDecline,
  isDisabled,
  isAccepting,
  isDeclining,
}: IndividualInviteCardProps) => {
  const inviterName = invite.inviter.name || invite.inviter.email;

  return (
    <div className="flex flex-col gap-3 rounded-lg border bg-gray-50 p-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <BriefcaseIcon className="h-4 w-4 shrink-0 text-gray-500" />
          <p className="text-sm font-medium text-gray-900">{invite.workspace.name}</p>
        </div>
        <p className="text-xs text-gray-600">
          Invited by {inviterName} on {formatTimestamp(invite.created_at)}
        </p>
      </div>
      <div className="flex gap-2 sm:ml-4">
        <Button
          size="sm"
          variant="outline"
          onClick={onDecline}
          disabled={isDisabled}
          isLoading={isDeclining}
        >
          Decline
        </Button>
        <Button size="sm" onClick={onAccept} disabled={isDisabled} isLoading={isAccepting}>
          Accept
        </Button>
      </div>
    </div>
  );
};
